import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
	const sliders = document.querySelectorAll('.wp-block-my-theme-slider');
	
	sliders.forEach((sliderElement) => {
		new Swiper(sliderElement, {
			// Deklarujemy moduły, których będziemy używać
			modules: [Navigation, Pagination, Autoplay],
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			pagination: {
				el: sliderElement.querySelector('.swiper-pagination'),
				clickable: true,
			},
			navigation: {
				nextEl: sliderElement.querySelector('.swiper-button-next'),
				prevEl: sliderElement.querySelector('.swiper-button-prev'),
			},
		});
	});
});
